import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx' // явно указываем расширение
import { AuthProvider } from './contexts/AuthContext.tsx'
import { ThemeContextProvider } from './contexts/ThemeContext'
import { ConfigProvider } from 'antd'
import ruRU from 'antd/locale/ru_RU'
import ErrorBoundary from './components/common/ErrorBoundary'
import './i18n/config' // Инициализируем i18n
import 'antd/dist/reset.css'

// Подавляем известную ошибку расширений Chrome (message channel closed before response)
const EXTENSION_MESSAGE_ERROR = 'message channel closed before a response was received';
window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message ?? String(event.reason ?? '');
  if (typeof msg === 'string' && msg.includes(EXTENSION_MESSAGE_ERROR)) {
    event.preventDefault();
    event.stopPropagation();
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find root element');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <ThemeContextProvider>
            <ConfigProvider locale={ruRU}>
              <App />
            </ConfigProvider>
          </ThemeContextProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
)